<template>
  <div class="material-manage-page">
    <el-form
      class="search-head"
      :inline="true"
      label-position="right"
      label-width="120px"
    >
      <el-form-item label="材料编组">
        <el-input v-model="form.groupName" />
      </el-form-item>
      <el-form-item label="项目">
        <el-select
          v-model="form.projectId"
          placeholder="请选择项目"
          clearable
          filterable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="患者姓名">
        <el-input v-model="form.patientName" />
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="form.idcard" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="form.status"
          placeholder="请选择状态"
          clearable
        >
          <el-option
            v-for="(item, index) in statusOption"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="患者来源">
        <el-select
          v-model="form.patientSource"
          placeholder="请选择患者来源"
          clearable
        >
          <el-option
            v-for="(item, index) in sourceOption"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="上传人">
        <el-input v-model="form.ftpUser" />
      </el-form-item>
      <el-form-item label="上传时间" class="date-box">
        <el-date-picker
          v-model="form.createdate"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item label="完成时间" class="date-box">
        <el-date-picker
          v-model="form.finishdate"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item label="材料名称">
        <el-select
          v-model="form.specialType"
          placeholder="请选择材料名称"
          clearable
        >
          <el-option
            v-for="(item, index) in specialList"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <div
        class="clearfix"
        style="display:flex;justify-content:flex-end;"
      >
        <el-form-item class="search-group">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div class="tabel-box">
      <el-table
        v-loading="listLoading"
        stripe
        style="width:100%"
        border
        :data="tableData"
      >
        <el-table-column prop="groupName" label="材料编组" />
        <el-table-column prop="projectName" label="项目" />
        <el-table-column prop="patientName" label="患者姓名" />
        <el-table-column label="状态">
          <template slot-scope="scope">
            <p>{{ getStatus(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="患者来源">
          <template slot-scope="scope">
            <p>{{ getPatientSource(scope.row.patientSource) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="上传时间">
          <template slot-scope="scope">
            <p>
              {{
                scope.row.createTime
                  | convertTime('YYYY-MM-DD HH:mm:ss')
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="完成时间">
          <template slot-scope="scope">
            <p v-if="scope.row.finishTime">
              {{
                scope.row.finishTime
                  | convertTime('YYYY-MM-DD HH:mm:ss')
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ftpUser" label="上传人" />

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="watch(scope.row.id)"
            >查看</el-button>
            <el-button
              v-if="getStatus(scope.row.status) != '匹配中'"
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleRead(scope.row)"
            >重新识别</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="lastexport">
        <el-row>
          <el-button
            type="primary"
            @click="exportFtp"
          >导出</el-button>
          <el-button @click="viewTask">查询结果</el-button>
        </el-row>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.pageIndex"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 查看导出ftp结果 -->
    <el-dialog title="导出结果" :visible.sync="dialogTableVisible">
      <el-table :data="tasklist">
        <el-table-column property="id" label="ID" width="150" />
        <el-table-column property="zipName" label="名称" width="200" />
        <el-table-column label="状态">
          <template slot-scope="scope">
            <p>{{ getFtpStatus(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="生成时间">
          <template slot-scope="scope">
            <p v-if="scope.row.commitTime">
              {{
                scope.row.commitTime
                  | convertTime('YYYY-MM-DD HH:mm:ss')
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="完成时间">
          <template slot-scope="scope">
            <p v-if="scope.row.finishTime">
              {{
                scope.row.finishTime
                  | convertTime('YYYY-MM-DD HH:mm:ss')
              }}
            </p>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="tasktotal > 0"
        :total="tasktotal"
        :page.sync="taskQuery.pageIndex"
        :limit.sync="taskQuery.pageSize"
        @pagination="taskList"
      />
    </el-dialog>
  </div>
</template>

<script>
import { projectquery } from '@/api/user'
import { commitGen } from '@/api/manage'
import {
  reLink,
  filegroupexport,
  taskpage,
  filegroupdelete
} from '@/api/manage'
import Pagination from '@/components/Pagination'
import { configlist } from '@/api/work'
import { mapGetters, mapState } from 'vuex'
export default {
  inject: ['reload'],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 7
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 30
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 90
              )
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      listLoading: false,
      specialList: [],
      options: [],
      sourceOption: [
        {
          label: '系统识别',
          value: 10
        },
        {
          label: '手动指定',
          value: 20
        },
        {
          label: '新患者',
          value: 30
        }
      ],
      statusOption: [
        {
          label: '待指定新患者',
          value: -70
        },
        {
          label: '识别多张身份证',
          value: -60
        },
        {
          label: '未识别患者信息',
          value: -50
        },
        {
          label: '未分配援助方式',
          value: 21
        },
        {
          label: '重复患者',
          value: -40
        },
        {
          label: '匹配中',
          value: 20
        },
        {
          label: '已完成',
          value: 30
        }
      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      total: 0, // 总个数
      form: {
        groupName: null,
        projectId: null,
        patientName: null,
        idcard: null,
        status: null,
        patientSource: null,
        ftpUser: null,
        createdate: null,
        finishdate: null,
        specialType: null,
        type: 2
      },
      firstSearch: {},
      tableData: [],
      dialogTableVisible: false,
      tasktotal: 0,
      taskQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      tasklist: []
    }
  },
  computed: {
    ...mapState({
      concentrateMode: state => state.editMode.concentrateMode
    }),
    ...mapGetters(['username'])
  },
  components: { Pagination },
  watch: {
    $route(to, form) {
      this.firstLoad()
    }
  },
  created() {
    projectquery().then(res => {
      this.options = res.data
    })
    configlist({ groupType: 2 }).then(res => {
      this.specialList = res.data
    })
    this.firstLoad()
  },
  methods: {
    resetForm() {
      this.firstSearch = {
        projectId: null, // 项目
        groupName: null, // 文件组
        idcard: null, // 身份证号
        status: null, // 状态 -50:未识别患者信息  0-初始化  20-匹配中 30-已完成
        patientSource: null, // 患者来源     10-系统识别 20-手动指定 30-新患者
        patientName: null, // 患者名称
        createBegTime: null,
        createEndTime: null, // 创建时间
        finishBegTime: null, // 结束时间
        finishEndTime: null, // 结束时间
        specialType: null,
        ftpUser: null,
        type: 2,
        pageIndex: 1,
        pageSize: 10
      }
      this.form = {
        groupName: null,
        projectId: null,
        patientName: null,
        idcard: null,
        status: null,
        patientSource: null,
        ftpUser: null,
        createdate: null,
        finishdate: null,
        specialType: null,
        type: 2
      }
      this.listQuery.pageIndex = 1
      this.listQuery.pageSize = 10
      this.initData(this.firstSearch)
      this.$router.replace({ query: null })
    },
    handleRead(row) {
      reLink(row.id)
        .then(res => {
          this.$message({
            message: res.message,
            type: 'success'
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    firstLoad() {
      if (this.$route.query.hasOwnProperty('createBegTime')) {
        this.firstSearch = { ...this.$route.query }
        delete this.firstSearch.id
        this.listQuery = {
          pageIndex: this.firstSearch.pageIndex * 1,
          pageSize: this.firstSearch.pageSize * 1
        }
        this.form = {
          groupName: this.firstSearch.groupName,
          projectId: this.firstSearch.projectId
            ? this.firstSearch.projectId * 1
            : null,
          patientName: this.firstSearch.patientName,
          specialType: this.firstSearch.specialType,
          idcard: this.firstSearch.idcard,
          status: this.firstSearch.status
            ? this.firstSearch.status * 1
            : null,
          patientSource: this.firstSearch.patientSource
            ? this.firstSearch.patientSource * 1
            : null,
          ftpUser: this.firstSearch.ftpUser,
          createdate: this.firstSearch.createBegTime
            ? [
              new Date(this.firstSearch.createBegTime * 1),
              new Date(this.firstSearch.createEndTime * 1)
						  ]
            : null,
          finishdate: this.firstSearch.finishBegTime
            ? [
              new Date(this.firstSearch.finishBegTime * 1),
              new Date(this.firstSearch.finishEndTime * 1)
						  ]
            : null,
          type: 2
        }
        console.log('this.form', this.form)
      } else {
        this.firstSearch = {
          projectId: null, // 项目
          groupName: null, // 文件组
          idcard: null, // 身份证号
          status: null, // 状态 -50:未识别患者信息  0-初始化  20-匹配中 30-已完成
          patientSource: null, // 患者来源     10-系统识别 20-手动指定 30-新患者
          patientName: null, // 患者名称
          specialType: null,
          createBegTime: null,
          createEndTime: null, // 创建时间
          finishBegTime: null, // 结束时间
          finishEndTime: null, // 结束时间
          ftpUser: null,
          type: 2,
          pageIndex: 1,
          pageSize: 10
        }
        this.form = {
          groupName: null,
          projectId: null,
          patientName: null,
          idcard: null,
          status: null,
          patientSource: null,
          specialType: null,
          ftpUser: null,
          createdate: null,
          finishdate: null,
          type: 2
        }
      }

      this.initData(this.firstSearch)
    },
    initData(data) {
      commitGen(data).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
        setTimeout(() => {
          this.listLoading = false
        }, 100)
      })
    },
    // 状态
    getStatus(data) {
      switch (data) {
        case -70:
          return '待指定新患者'
          break
        case -60:
          return '识别多张身份证'
          break
        case 21:
          return '未分配援助方式'
          break
        case -50:
          return '未识别患者信息'
          break
        case -100:
          return '错误'
          break
        case 0:
          return '初始化'
          break
        case -40:
          return '重复患者'
          break
        case 20:
          return '匹配中'
          break
        case 30:
          return '已完成'
          break
      }
    },
    // 患者来源
    getPatientSource(data) {
      switch (data) {
        case 0:
          return '无'
          break
        case 10:
          return '系统识别'
          break
        case 20:
          return '手动指定'
          break
        case 30:
          return '新患者'
          break
      }
    },
    getList() {
      this.firstSearch.pageIndex = this.listQuery.pageIndex
      this.firstSearch.pageSize = this.listQuery.pageSize
      var query = JSON.parse(JSON.stringify(this.firstSearch))
      query.id = Math.random()

      this.$router.replace({ query: query })
      this.initData(this.firstSearch)
    },
    search() {
      this.firstSearch.groupName = this.form.groupName
        ? this.form.groupName.trim()
        : null
      this.firstSearch.projectId = this.form.projectId
        ? this.form.projectId * 1
        : null
      this.firstSearch.patientName = this.form.patientName
        ? this.form.patientName.trim()
        : null
      this.firstSearch.idcard = this.form.idcard
        ? this.form.idcard.trim()
        : null
      this.firstSearch.specialType = this.form.specialType
      if (this.form.status || this.form.status === 0) {
        this.firstSearch.status = this.form.status
      } else {
        this.firstSearch.status = null
      }
      this.firstSearch.patientSource = this.form.patientSource
        ? this.form.patientSource
        : null
      this.firstSearch.ftpUser = this.form.ftpUser
        ? this.form.ftpUser.trim()
        : null
      this.form.patientName ? this.form.patientName.trim() : null
      this.firstSearch.createBegTime = this.form.createdate
        ? this.form.createdate[0].getTime()
        : null
      this.firstSearch.createEndTime = this.form.createdate
        ? this.form.createdate[1].getTime()
        : null
      this.firstSearch.finishBegTime = this.form.finishdate
        ? this.form.finishdate[0].getTime()
        : null
      this.firstSearch.finishEndTime = this.form.finishdate
        ? this.form.finishdate[1].getTime()
        : null
      this.listQuery.pageIndex = 1
      this.initData(this.firstSearch)
      var query = JSON.parse(JSON.stringify(this.firstSearch))
      query.id = Math.random()

      this.$router.replace({ query: query })
      console.log('this.$router', this.$route)
    },
    watch(id) {
      this.$router.push({ name: 'logisticswatch', params: { id: id }})
    },
    handleEdit(row) {
      const info = {
        id: 1
      }
      if (this.concentrateMode) {
        // 如果已经有专注编辑页签打开
        // this.$store.state.tagsView.visitedViews.forEach(item => {
        // 	if (item.name == 'concentrateLogistics'||item.name == 'concentrateMaterial') {
        // 		// 删除已打开的专注编辑页签
        // 		this.$store.dispatch('tagsView/delView', item)
        // 	}
        // })
        // 进入专注编辑
        this.$router.push({
          name: 'concentrateLogistics',
          params: {
            id: row.id,
            projectId: row.projectId
          }
        })
      } else {
        this.$router.push({
          name: 'logisticsedit',
          params: {
            id: row.id,
            projectId: row.projectId
          }
        })
      }
    },
    // 导出材料到ftp
    exportFtp() {
      if (this.username.indexOf('admin') != -1) {
        if (this.tableData.length) {
          this.$confirm('是否导出当前筛选结果', '导出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              var arr = []
              this.tableData.forEach(item => {
                arr.push(item.id)
              })
              var str = arr.join(',')
              filegroupexport(str)
                .then(res => {
                  this.$message({
                    message: res.data,
                    type: 'success'
                  })
                })
                .catch(err => {
                  this.$message({
                    message: err.message,
                    type: 'error'
                  })
                })
            })
            .catch(() => {})
        } else {
          return false
        }
      } else {
        this.$message.error('无操作权限，请联系管理员')
      }
    },
    // 查看导出材料
    viewTask() {
      this.taskQuery = {
        pageIndex: 1,
        pageSize: 10
      }
      const info = {
        pageIndex: this.taskQuery.pageIndex,
        pageSize: this.taskQuery.pageSize
      }
      taskpage(info)
        .then(res => {
          this.dialogTableVisible = true
          this.tasklist = res.data.records
          this.tasktotal = res.data.total
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    getFtpStatus(type) {
      switch (type) {
        case 10:
          return '等待导出结果'
          break
        case 20:
          return '等待导出结果'
          break
        case 30:
          return '已生成'
          break
      }
    },
    taskList() {
      const info = {
        pageIndex: this.taskQuery.pageIndex,
        pageSize: this.taskQuery.pageSize
      }
      taskpage(info).then(res => {
        this.tasklist = res.data.records
      })
    },
    handleDelete(row) {
      if (this.username.indexOf('admin') != -1) {
        if (!row.fileNum) {
          filegroupdelete(row.id)
            .then(res => {
              this.$message({
                message: res.message,
                type: 'success'
              })
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        } else {
          this.$confirm(
            '该文件组内包含材料，删除分组将同时删除材料，是否确认删除',
            '删除分组',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              filegroupdelete(row.id)
                .then(res => {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  })
                })
                .catch(err => {
                  this.$message.error(err.message)
                })
            })
            .catch(() => {})
        }
      } else {
        this.$message.error('无操作权限，请联系管理员')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.material-manage-page {
	.search-head {
		padding: 0 20px;
	}
	.tabel-box {
		padding: 20px 30px;
	}
}
@media (max-width: 1920px) {
	.search-group {
		float: right;
		margin-right: 100px;
	}
}
@media (max-width: 992px) {
	.search-group {
		float: right;
		margin-right: 120px;
	}
}
@media (max-width: 768px) {
	.search-group {
		float: left;
		margin-left: 120px;
	}
}
.search-group {
	float: left;
	margin-left: 120px;
}
</style>
<style lang="scss">
.material-manage-page {
	.search-head {
		font-size: 0px;
		.el-input__inner {
			width: 195px;
		}
	}
	.el-form-item {
		width: 315px;
	}
	.date-box {
		width: 490px;
		.el-date-editor {
			width: 360px;
			.el-range-input {
				width: 150px;
			}
		}
	}
}
</style>
